module.exports = "wiki"